import { render, staticRenderFns } from "./Please_Verify.vue?vue&type=template&id=6cca4fbc&"
import script from "./Please_Verify.vue?vue&type=script&lang=js&"
export * from "./Please_Verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports